import React, { useEffect, Suspense, lazy, useState } from "react";
import { withWidth } from "@material-ui/core";
import { GetChannelCode } from "../../const";
import { useLocation } from "react-router-dom";
import { Spinner, SpinnerSize } from "office-ui-fabric-react"

function Index() {
    const [ChannelWidget, setChannelWidget] = React.useState(lazy(() => import(`./initialWidget`)));
    const location = useLocation()
    const [isAuth , setIsAuth] = useState(false)
    

    useEffect(() => {
        GetChannelCode().then(res => {
            if(location.pathname.includes("/auth/callback"))  {
                setChannelWidget(lazy(() => import(`./Channel/MANAGEX/AuthCallback`)));
            }
            else if(location.pathname.includes("/blueprint-view")) {
                setChannelWidget(lazy(() => import(`../BlueprintView`)));
            }
           else {
                try {
                    setChannelWidget(lazy(() => import(`./Channel/${res.data.data}`)));
                } catch {
                    setChannelWidget(lazy(() => import(`./Channel/MANAGEX`)));
                }
            }
        })
    }, []);

    return (
        <React.Fragment>
            <Suspense fallback={
                <Spinner styles={{ root: { marginTop: '5px' } }} size={SpinnerSize.medium} label="Loading...."
                    ariaLive="assertive" labelPosition="right" />} >
                <ChannelWidget setIsAuth={setIsAuth} />
            </Suspense>
        </React.Fragment>
    );

}

export default withWidth()(Index);

